module.exports = __webpack_public_path__ + "img/53f099e6a54d627a2742b2a93afe8789.png";